import { translate } from "app/filters/i18nFilter";
import { MY_LISTS_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import ErrorContentBase from "app/pages/sales-intelligence/pages/home/components/common/ErrorContentBase/ErrorContentBase";
import ListsCard from "app/pages/sales-intelligence/pages/home/components/ListsCard/ListsCard";
import ListsCardContainer from "app/pages/sales-intelligence/pages/home/containers/ListsCardContainer/ListsCardContainer";
import RedirectButtonTracked from "app/pages/sales-intelligence/pages/home/containers/RedirectButton/RedirectButtonTracked";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";
import { CardEventCategory } from "app/pages/sales-intelligence/services/tracking/home-page/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { withErrorBoundary } from "react-error-boundary";

const ListsCardWithErrorBoundary = withErrorBoundary(ListsCardContainer, {
    fallbackRender() {
        const metadata: ViewModelMetadata = {
            trackingCategory: CardEventCategory.Lists,
            totalResultsCount: 0,
        };

        const handleClick = () => {
            proNavigator.go(MY_LISTS_PAGE_ROUTE);
        };

        return (
            <ListsCard metadata={metadata}>
                <ErrorContentBase
                    title={{ key: "si.pages.home.card.common.error.title" }}
                    subtitle={{ key: "si.pages.home.card.lists.error.subtitle" }}
                >
                    <RedirectButtonTracked
                        metadata={metadata}
                        type="primary"
                        onClick={handleClick}
                    >
                        {translate("si.pages.home.card.lists.action.view-lists")}
                    </RedirectButtonTracked>
                </ErrorContentBase>
            </ListsCard>
        );
    },
});

export default ListsCardWithErrorBoundary;
